import { render, staticRenderFns } from "./readList.vue?vue&type=template&id=e665fb4a&scoped=true"
import script from "./readList.vue?vue&type=script&lang=js"
export * from "./readList.vue?vue&type=script&lang=js"
import style0 from "./readList.vue?vue&type=style&index=0&id=e665fb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e665fb4a",
  null
  
)

export default component.exports